<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Kunde"
        @save="saveCustomerFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true && formContext.isInEditMode"
            v-slot:after-icons>
            <csp-retroactive-changes-modal
                button-text=" Aktualisierung weiterer Daten anfragen"
                :record-id="recordId" title="Kunde"/>
        </template>
        <div v-if="showChangelogButton" class="float-right">
            <csp-changelog-modal :changelog-url="customerChangelogUrl"/>
        </div>
        <h2>Grunddaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Kundennummer"
                property="customerNumber"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Anrede"
                property="gender"
                :required="true"
                type="radio"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :label="personLabelPrefix + 'Titel'"
                property="title"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :label="personLabelPrefix + 'Vorname'"
                property="firstName"
                :required="!isGenderCompany"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :label="personLabelPrefix + 'Nachname'"
                property="lastName"
                :required="!isGenderCompany"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Firmenname"
                property="companyName"
                :required="isGenderCompany"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Straße"
                property="street"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="PLZ"
                property="postalCode"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ort"
                property="place"
                :required="true"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Land"
                :options-loader="loadCountryOptions"
                property="country"
                type="autocomplete"/>
        </b-row>
        <hr>
        <h2>Kontaktdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Mobil"
                property="phoneMobile"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Telefon geschäftlich"
                property="phoneBusiness"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Telefon privat"
                property="phonePrivate"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6 "
                :form-context="formContext"
                label="E-Mail"
                property="email"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CustomerBasedata',
        mixins: [FormDataMixin],
        computed: {
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            customerChangelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/customer/changelog';
            },
            isGenderCompany() {
                return this.formContext.form.getProperty('gender') === 'company';
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
            personLabelPrefix() {
                if (this.isGenderCompany) {
                    return 'Ansprechpartner ';
                }

                return '';
            },
        },
        methods: {
            loadCountryOptions() {
                return recordRepository.loadLegacySelectOptions('countries')
            },
            saveCustomerFormData(formContext) {
                let saveFunction;

                if (this.formContext.permissions.canCreateRetroactiveChangesNote) {
                    saveFunction = (objectId, postData) => {
                        return recordRepository.saveCustomerNumber(this.recordId, postData)
                    }
                } else {
                    saveFunction = (objectId, postData) => {
                        return recordRepository.saveCustomerBasedata(this.recordId, postData)
                    }
                }
                this.saveFormData(formContext, saveFunction, null);
            },
            reloadCustomerFormData(formContext) {
                const reloadFunction = (objectId, postData) => {
                    return recordRepository.reloadCustomerBasedata(this.recordId, postData)
                }
                this.reloadFormData(formContext, reloadFunction, null)
            },
        },
    }
</script>
